import { combineReducers, Action } from 'redux';
import { businessListReducer } from './businessReducer';

export const sharedModuleReducer = combineReducers({
    businessList: businessListReducer,
});